import { palette } from '@dev/ee-components';

export const DEFAULT_PER_PAGE_COUNT = 25;
export const DEFAULT_PER_PAGE_TEMPLATES_COUNT = 24;
export const DEFAULT_OFFSET = 0;
export const DEFAULT_ACTIVE_PAGE = 1;
export const SHORT_DATE_FORMAT = 'YYYY-MM-DD';
export const LONG_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
export const DISPLAY_DATE_FORMAT_DOTS = 'DD.MM.YYYY hh:mm:ss';
export const LONG_DATE_FORMAT_DOTS_24H = 'DD.MM.YYYY HH:mm:ss';
export const TIME_RANGE_WEEK = 7;
export const TIME_RANGE_3_DAYS = 3;
export const TIME_RANGE_TWO_WEEKS = 14;
export const TIME_RANGE_1_DAY = 1;
export const TIME_RANGE_60_MINUTES = 60;
export const TIME_RANGE_0_MINUTES = 0;
export const TIME_RANGE_MONTH = 30;
export const TIME_RANGE_35_DAYS = 35;
export const TIME_RANGE_THREE_MONTHS = 90;
export const TIME_RANGE_SIX_MONTHS = 180;
export const TIME_RANGE_YEAR = 365;
export const ALL_CONTACTS_SEGMENT = 'All Contacts';
export const TIME_RANGES = [
    TIME_RANGE_WEEK,
    TIME_RANGE_TWO_WEEKS,
    TIME_RANGE_MONTH,
    TIME_RANGE_THREE_MONTHS,
    TIME_RANGE_SIX_MONTHS,
    TIME_RANGE_YEAR,
];
export const ACTIVITY_TIME_RANGES = [
    TIME_RANGE_1_DAY,
    TIME_RANGE_3_DAYS,
    TIME_RANGE_WEEK,
    TIME_RANGE_TWO_WEEKS,
    TIME_RANGE_35_DAYS,
];
export const EMPTY = 0;

export const ALPHABET = 'abcdefghijklmnopqrstuvwxyz'.split('');
export const MINUTES_IN_DAY = 1440;
export const LIMITED_LOGS_DAYS_PRO = 7;
export const LIMITED_LOGS_DAYS = 3;
//TODO: As this price is not in account model, for now we store it as const
export const EXTENDED_LOGS_PRICE_PER_DAY = 2;

export const BarChartColors = [
    {
        bgColor: palette.indigo[6],
        txtColor: palette.basic.paper,
    },
    {
        bgColor: palette.teal[4],
        txtColor: palette.jacarta[5],
    },
    {
        bgColor: palette.red[3],
        txtColor: palette.jacarta[5],
    },
    {
        bgColor: palette.orange[4],
        txtColor: palette.jacarta[5],
    },
    {
        bgColor: palette.blue[3],
        txtColor: palette.jacarta[5],
    },
    {
        bgColor: palette.indigo[4],
        txtColor: palette.basic.paper,
    },
    {
        bgColor: palette.jacarta[2],
        txtColor: palette.jacarta[5],
    },
    {
        bgColor: palette.green[3],
        txtColor: palette.jacarta[5],
    },
    {
        bgColor: palette.green[5],
        txtColor: palette.jacarta[5],
    },
    {
        bgColor: palette.green[9],
        txtColor: palette.basic.paper,
    },
    {
        bgColor: palette.orange[6],
        txtColor: palette.jacarta[5],
    },
    {
        bgColor: palette.orange[8],
        txtColor: palette.basic.paper,
    },
    {
        bgColor: palette.teal[4],
        txtColor: palette.jacarta[5],
    },
    {
        bgColor: palette.teal[7],
        txtColor: palette.jacarta[5],
    },
    {
        bgColor: palette.teal[8],
        txtColor: palette.basic.paper,
    },
    {
        bgColor: palette.purple[5],
        txtColor: palette.jacarta[5],
    },
    {
        bgColor: palette.purple[7],
        txtColor: palette.basic.paper,
    },
    {
        bgColor: palette.purple[8],
        txtColor: palette.basic.paper,
    },
    {
        bgColor: palette.purple[9],
        txtColor: palette.basic.paper,
    },
    {
        bgColor: palette.snow[5],
        txtColor: palette.jacarta[5],
    },
];

export const MAX_CAMPAIGNS_LIST_LENGTH = 20;
export const MAX_CAMPAIGNS_LIST_WITH_QUERY_LENGTH = 100;

export const MAX_CHANNELS_LIST_LENGTH = 20;
export const MAX_CHANNELS_LIST_WITH_QUERY_LENGTH = 100;

export const INFO_TOAST_DURATION = 6000;
export const SUCCESS_TOAST_DURATION = 6000;
export const WARNING_TOAST_DURATION = 6000;
export const ERROR_TOAST_DURATION = 6000;

export const INDEX_PLACEHOLDER = '{{0}}';
export const DEFAULT_TAB_ID = '0';

export const DEFAULT_OPENED_ONBOARDING_TASK_ID = -1;
export const DEFAULT_OPENED_ONBOARDING_STEP_ID = -1;

export const SYSTEM_FIELD_MAX_FIELD_LENGTH = 253;
export const CUSTOM_FIELD_MAX_FIELD_LENGTH = 255;
export const CUSTOM_FIELD_DEFAULT_FIELD_LENGTH = 100;

export const YT_GENERATE_API_KEY_ID = 'aWuTNPaaP5E';
export const YT_GENERATE_SMTP_KEY = 'WM1z8ZmKYP0';
export const YT_CREATE_FORMS = '2kty9FpK7O8'

export const LANDING_PAGE_DOMAIN = 'myelasticemail.com';
export const DEFAULT_LANDING_SUBDOMAIN = 'subdomain';
export const MAX_SUFFIX_LENGTH = 600;

export const LANDING_PAGE_ID_FOR_SETTING_ACCOUNT_SUBDOMAIN = 0;
